var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "subheader" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { top: "50vh", height: "90vh" },
                attrs: { id: "main-container" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { height: "82vh" },
                    attrs: { id: "container" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh lc",
                        staticStyle: { width: "100%", height: "65px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fh lc",
                            staticStyle: {
                              width: "23%",
                              height: "100%",
                              "margin-left": "23px"
                            }
                          },
                          [
                            _c("div", {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { id: "circulo" + _vm.estadoPedido }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  "font-weight": "400",
                                  color: "#5D6770",
                                  "margin-left": "5px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.estado(_vm.estadoPedido)) + " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { id: "list-container" } },
                      _vm._l(_vm.productosCP, function(item) {
                        return _c("item-pedido", {
                          attrs: { id: "list-prod", item: item }
                        })
                      })
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fv rc",
                        staticStyle: { width: "100%", "margin-top": "10px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Subtotal: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.subtotal)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Descuentos: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.descuentosCP)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Impuestos: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.impuestosTotal)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Total: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "14px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.subtotal -
                                          _vm.descuentosCP +
                                          _vm.impuestosTotal
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "btnContainer" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "fh cc btnEmpty1",
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "9px"
                          },
                          on: { click: _vm.btnTransformarEnPedido }
                        },
                        [_vm._v("TRANSFORMAR EN PEDIDO")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          id: "btnReplicar",
                          type: "submit",
                          value: "REPLICAR"
                        },
                        on: { click: _vm.btnReplicar }
                      })
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: {
                  width: "100vw",
                  height: "100vh",
                  "margin-top": "40px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "4%",
                      background: "#44C7F4",
                      color: "white",
                      font: "size 12px"
                    }
                  },
                  [_vm._v("Ver Pedido")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "40px",
                      "margin-top": "0px",
                      background: "#ffffff"
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { id: "circulo" + _vm.estadoPedido }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          "font-weight": "400",
                          color: "#5D6770",
                          "margin-right": "26px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.estado(_vm.estadoPedido)) + " ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: {
                      width: "100%",
                      height: "50px",
                      "margin-top": "0px",
                      background: "#eeeeee"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh rc",
                        staticStyle: { width: "100%", height: "100%" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: { width: "33%", height: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh cb",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v("Subtotal")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh ct",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(_vm._f("formatMoney")(_vm.subtotal))
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: { width: "33%", height: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh cb",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v("Descuentos")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh ct",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " -$" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.descuentosCP)
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: { width: "33%", height: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh cb",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v("Impuestos")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh ct",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.impuestosTotal)
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv cc",
                            staticStyle: { width: "33%", height: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh cb",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "15px",
                                  "font-weight": "500",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v("Total")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh ct",
                                staticStyle: {
                                  width: "100%",
                                  height: "50%",
                                  "font-size": "12px",
                                  color: "#5D6770",
                                  "font-weight": "500"
                                }
                              },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.subtotal -
                                          _vm.descuentosCP +
                                          _vm.impuestosTotal
                                      )
                                    )
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv ct",
                    staticStyle: {
                      width: "100%",
                      height: "60%",
                      overflow: "auto",
                      "margin-top": "20px"
                    }
                  },
                  _vm._l(_vm.productosCP, function(item) {
                    return _c("item-pedido", {
                      attrs: { id: "list-prod", item: item }
                    })
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc btnFull1",
                    staticStyle: { "font-weight": "500", "margin-top": "10px" },
                    on: { click: _vm.btnReplicar }
                  },
                  [_vm._v("REPLICAR")]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fv lc", staticStyle: { width: "700px", height: "10vh" } },
      [_c("span", { attrs: { id: "label" } }, [_vm._v("Ver Presupuesto")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47cacc03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cacc03","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/presupuestoCms.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-47cacc03","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/presupuestoCms.vue
// module chunks = 0